<template>
    <div class="gameArea"> 
        <ul>
            <li @click="fill('a1')"> {{ xo.a1 }} </li>
            <li @click="fill('a2')">   {{ xo.a2 }}  </li>
            <li @click="fill('a3')">  {{ xo.a3 }} </li>
        </ul>
        <ul>
            <li @click="fill('b1')" >  {{ xo.b1 }} </li>
            <li @click="fill('b2')">  {{ xo.b2 }} </li>
            <li @click="fill('b3')">  {{ xo.b3 }} </li>
        </ul>
        <ul>
            <li @click="fill('c1') ">  {{ xo.c1 }} </li>
            <li @click="fill('c2') ">  {{ xo.c2 }} </li>
            <li @click="fill('c3')">  {{ xo.c3 }} </li>
        </ul>
    </div>
</template>


<script>

export default {
    data() {
        return {
            xo : { a1 : '', a2 : '', a3: '', b1: '', b2: '', b3: '', c1: '', c2: '', c3: ''  },
            size : '',
            
        }
    },
    methods :  {

        success() {
            this.$emit("successEvent", "success");
        },

        lose() {
            this.$emit("loseEvent", "lose");
        },
        withdraw() {
            this.$emit("withDraw", "withdraw");
        },

        check() {
               setTimeout(() => {
if( this.xo.a1 == "X" && this.xo.a2 == "X" && this.xo.a3 == "X"  ) {
                this.success();
            }
else if( this.xo.a1 == "X" && this.xo.b1 == "X" && this.xo.c1 == "X"  ) {
                this.success();
            }
else if( this.xo.a1 == "X" && this.xo.b2 == "X" && this.xo.c3 == "X"  ) {
                this.success();
            }
else if( this.xo.a2 == "X" && this.xo.b2 == "X" && this.xo.c2 == "X"  ) {
                this.success();
            }
else if( this.xo.a3 == "X" && this.xo.b2 == "X" && this.xo.c1 == "X"  ) {
                this.success();
            }
else if( this.xo.a3 == "X" && this.xo.b3 == "X" && this.xo.c3 == "X"  ) {
                this.success();
            }
else if( this.xo.b1 == "X" && this.xo.b2 == "X" && this.xo.b3 == "X"  ) {
                this.success();
            }
else if( this.xo.c1 == "X" && this.xo.c2 == "X" && this.xo.c3 == "X"  ) {
                this.success();
            }
else if( this.xo.a1 == "O" && this.xo.a2 == "O" && this.xo.a3 == "O"  ) {
                 this.lose();
            }
else if( this.xo.a1 == "O" && this.xo.b1 == "O" && this.xo.c1 == "O"  ) {
                this.lose();
            }
else if( this.xo.a1 == "O" && this.xo.b2 == "O" && this.xo.c3 == "O"  ) {
               this.lose();
            }
else if( this.xo.a3 == "O" && this.xo.b2 == "O" && this.xo.c1 == "O"  ) {
               this.lose();
            }
else if( this.xo.a2 == "O" && this.xo.b2 == "O" && this.xo.c2 == "O"  ) {
              this.lose();
            }
else if( this.xo.c1 == "O" && this.xo.c2 == "O" && this.xo.c3 == "O"  ) {
              this.lose();
            }
else if( this.xo.b1 == "O" && this.xo.b2 == "O" && this.xo.b3 == "O"  ) {
               this.lose();
            }

else if( this.xo.a3 == "O" && this.xo.b3 == "O" && this.xo.c3 == "O"  ) {
               this.lose();
            }
else if( this.size == 0 ) {
               this.withdraw();
            }
            },100)
        },

        
        fill(dt) {  // eslint-disable-line no-unused-vars

            
            if(this.xo.[dt] == '') {
            this.xo.[dt]= 'X';
            
            let xo2 = this.xo;

            let fillComp = Object.keys(xo2).filter(function(key,index) {  // eslint-disable-line no-unused-vars

                return xo2[key] == ''; 

            })

            

            this.size = fillComp.length;
            console.log(this.size);

          let randomInt =  Math.floor(Math.random() * fillComp.length);

            this.xo.[fillComp[randomInt]]= 'O';

            


            }

         this.check();


            


         
            
            }



            
        }

    }


</script>


<style scoped>

.gameArea {
    color: #fff;
}

ul {
    display: flex;
   list-style: none;
}

li {
    width: 7rem;
    height: 7rem;
    font-size: 5rem;
    font-weight: 800;
    padding: 0px 1.5rem;
    cursor: pointer;
}
ul:first-child {
   border-bottom: 1px solid #fff;
}
ul:nth-child(2) {
   border-bottom: 1px solid #fff;
}

li:nth-child(1) {
    border-right: 1px solid #fff;
}

li:nth-child(2) {
    border-right: 1px solid #fff;
}


</style>